export const editName = "question" as const;
export const renderName = "Question" as const;
